import axios from 'axios'

export const getFeedList = (type = 'images', params = {}) => {
  return axios.get(`/api/feed/${type}`, { params })
} 